<!--订单页 搜索项-->
<template>
    <v-container fluid>
		<div class="search">
			<div class="time">
				<el-date-picker
					v-model="form.time"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					format="yyyy 年 MM 月 dd 日"
					value-format="timestamp"
					style="width:98%;"
					:picker-options="pickerOptions"
				></el-date-picker>
			</div>
			<div class="box1">
				<el-select v-model="form.status" clearable placeholder="订单状态">
					<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select>
			</div>
			<div class="box1" v-if="role === 0">
				<select-cec :width="'98%'" :cecId="form.cec_id" @chooseCec="chooseCec" />
			</div>
			<div class="box1">
				<select-site
					ref="selectSite"
					@choose="chooseSite"
					:selectSite="form.selectSiteId"
					:width="'98%'"
				/>
			</div>
			<div class="box1" v-if="role === 0">
				<select-platform
					@choose="choosePlatformId"
					:selectPlatform="form.platform_id"
					:width="'98%'"
				/>
			</div>
			<div class="box1">
				<el-input
					type="text"
					v-model="form.connector_id"
					clearable
					style="width: 98%"
					placeholder="充电枪"
				></el-input>
			</div>
			<div class="box1">
				<el-input
					type="text"
					v-model="form.mobile"
					clearable
					style="width: 98%"
					placeholder="手机号码"
				></el-input>
			</div>
			<div class="box1">
				<el-input
					type="text"
					v-model="form.no"
					clearable
					style="width: 98%"
					placeholder="订单号"
				></el-input>
			</div>
			<div class="btn-search">
				<el-button
					type="primary"
					icon="el-icon-search"
					@click="search()"
					size="medium"
				></el-button>
			</div>
		</div>
    </v-container>
</template>

<script>
import util from "@/util";
import store from "@/store";
import SelectSite from "@/components/SelectSite";
import SelectPile from "@/components/SelectPile";
import SelectCec from "@/components/SelectCec";
import SelectPlatform from "@/components/SelectPlatform";
import { mapState } from "vuex";
import Public from "@/public";
export default {
    data() {
        return {
            form: {
                time: null, //时间
                mobile: null, //手机号
                no: null, //订单号
                selectSiteId: null, //选中的站点
                cec_id: null, //互联互通id
                connector_id: null, //充电枪编号
                status: null, //订单状态
				platform_id: null,
            },
            cecInfo: [],
            connectorInfos: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "昨天",
                        onClick(picker) {
                            const now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            let start = new Date(lastData).getTime() - 8 * 60 * 60 * 1000;
                            let end = start + 23 * 3600 * 1000 + 59 * 60000 + 59 * 1000 - 1;
                            console.log(Public.longDataToStr2(start));
                            console.log(Public.longDataToStr2(end));
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            let now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 7);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            const start = new Date(lastData).getTime();
                            const end = new Date();
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            let now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 30);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            const start = new Date(lastData).getTime();
                            const end = new Date();
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            let now = new Date();
                            now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 90);
                            let lastData =
                                now.getFullYear() +
                                "-" +
                                (now.getMonth() + 1) +
                                "-" +
                                now.getDate();
                            const start = new Date(lastData).getTime();
                            const end = new Date();
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            isExportLoading: false, //导出订单
            options: [
                {
                    value: "0",
                    label: "启动中",
                },
                {
                    value: "1",
                    label: "充电中",
                },
                {
                    value: "2",
                    label: "启动失败",
                },
                {
                    value: "3",
                    label: "完成",
                },
                {
                    value: "4",
                    label: "待支付",
                },
                {
                    value: "5",
                    label: "正在生成订单",
                },
            ],
        };
    },
    components: {
        SelectSite,
        SelectPile,
        SelectCec,
		SelectPlatform
    },
    props: {
        isClickData: Boolean,
    },
    watch: {
        form: {
            handler(val) {
                // this.search();
            },
            deep: true,
        },
        "form.selectSiteId": {
            handler(val) {
                this.$refs.selectSite.getSite();
                this.$refs.selectSite.site = val;
                if (!val) {
                    this.search();
                }
            },
        },
        "form.mobile": {
            handler(val) {
                if (!val || val.length == 11) {
                    this.search();
                }
            },
        },
        "form.connector_id": {
            handler(val) {
                if (!val) {
                    this.search();
                }
            },
        },
        "form.no": {
            handler(val) {
                this.search();
            },
        },
        "form.time": {
            handler(val) {
                this.search();
            },
        },
		"form.platform_id": {
		    handler(val) {
		        this.search();
		    },
		},
		"form.status": {
		    handler(val) {
		        this.search();
		    },
		},
		"form.cec_id": {
		    handler(val) {
		        this.search();
		    },
		},
        isClickData: {
            handler() {
                this.search();
            },
        },
    },
    computed: {
        ...mapState(["contactInfo", "theme", "orderBlob", "siteIdList","role","platform_id"]),
    },
    async mounted() {
        this.firstTimeData();
        await store.dispatch("getStationIdList", {});
    },
    methods: {
        firstTimeData() {
            let now = new Date();
            let y = now.getFullYear();
            let m = now.getMonth() + 1;
            let d = now.getDate();
            let endTime = y + "-" + m + "-" + d;
            now.setMonth(now.getMonth() - 1);
            y = now.getFullYear();
            m = now.getMonth() + 1;
            d = now.getDate();
            let startTime = y + "-" + m + "-" + d;
            let start_time = new Date(startTime).getTime() + 24 * 60 * 60 * 1000;
            let end_time = new Date(endTime).getTime();
            this.form.time = [start_time, end_time];
			if(this.role !== 0) {
				 this.form.platform_id = this.platform_id;
			}
            this.search();
        },
        chooseCec(cecId) {
            this.form.cec_id = cecId;
        },
        /*选择站点*/
        chooseSite(site) {
            this.form.selectSiteId = site.siteId;
            this.search();
        },
		/*选择平台*/
		choosePlatformId(platformId) {
		    this.form.platform_id = platformId;
		    this.search();
		},
        /*搜索*/
        search() {
            let now = new Date();
            let endTime = null;
            let startTime = null;
            if (this.form.time && this.form.time[1] != this.form.time[0]) {
                // startTime = Math.floor(this.form.time ? this.form.time[0] / 1000 : 0);
                // endTime =
                //     Math.floor((this.form.time ? this.form.time[1] : now.getTime()) / 1000) + 86400;
                startTime = new Date(this.form.time[0]).getTime() / 1000;
                endTime =
                    (new Date(Public.longDataToStr(this.form.time[1]).split(" ")[0]).getTime() -
                        8 * 1000 * 3600 +
                        24 * 3600 * 1000) /
                    1000;
            } else if (this.form.time && this.form.time[1] == this.form.time[0]) {
                startTime = Math.floor(this.form.time ? this.form.time[0] / 1000 : 0);
                endTime = Math.floor(this.form.time[0] / 1000) + 24 * 60 * 60;
            }
            // console.log(endTime);
            console.log(Public.longDataToStr(startTime * 1000));
            console.log(Public.longDataToStr(endTime * 1000));
			if(Number(this.form.mobile) && !this.form.platform_id) {
				util.ShowTip("平台不能为空", 3);
				return;
			}
            let postData = {
                cec_id: Number(this.form.cec_id),
                station_id: this.form.selectSiteId ? Number(this.form.selectSiteId) : null,
                end_time: endTime,
                start_time: startTime,
                tel: Number(Public.removeSpace(this.form.mobile)),
                no: Public.removeSpace(this.form.no),
                connector_id: Public.removeSpace(this.form.connector_id),
				platform_id: this.form.platform_id
            };
            if (this.form.status != "" && this.form.status != null) {
                postData["status"] = Number(this.form.status);
            } else {
                delete postData["status"];
            }
            Object.keys(postData).forEach(key => {
                if (key == "status") {
                    if (postData[key] == null) {
                        delete postData["status"];
                    }
                } else if (!postData[key]) {
                    delete postData[key];
                }
            });
            console.log(postData.station_id);
            this.$emit("search", postData);
        },
        /*导出订单*/
        async exportOrder() {
            if (!this.form.time) {
                util.ShowTip("请选择时间范围", 3);
                return;
            }
			if(!this.form.platform_id) {
				util.ShowTip("请选择平台", 3);
				return;
			}
			const loading = this.$loading({
			    lock: true,
			    text: '正在加载...',
			    spinner: 'el-icon-loading',
			    background: 'rgba(0, 0, 0, 0.7)'
			});
            // let time = this.form.time[1] + 3600 * 24 * 1000 - this.form.time[0];
            // if (time > 31 * 24 * 3600 * 1000) {
            //     util.ShowTip("超出时间范围，选择时间差不能超过31天", 3);
            //     return;
            // }
            this.isExportLoading = true;
            let now = new Date();
            let endTime = null;
            let startTime = null;
            console.log(Public.longDataToStr2(this.form.time[1]));
            // console.log(Public.longDataToStr2(now.getTime()).substr(0, 10));
            if (this.form.time && this.form.time[1] > now.getTime()) {
                startTime = Math.floor(this.form.time[0] / 1000);
                endTime = Math.floor(now.getTime() / 1000);
            } else if (
                this.form.time &&
                this.form.time[1] != this.form.time[0] &&
                this.form.time[1] < now.getTime()
            ) {
                console.log(1);
                // console.log(Public.longDataToStr2(this.form.time[0]));
                // console.log(Public.longDataToStr2(this.form.time[1]));
                startTime = Math.floor(this.form.time[0] / 1000);
                endTime = this.form.time[1] / 1000 + 24 * 60 * 60;
                // console.log(Public.longDataToStr2(endTime * 1000));
            } else if (
                this.form.time &&
                this.form.time[1] == this.form.time[0] &&
                this.form.time[1] <= now.getTime()
            ) {
                console.log(2);
                startTime = Math.floor(this.form.time[0] / 1000);
                endTime = Math.floor(this.form.time[0] / 1000) + 86400;
            }
            if (
                this.form.time &&
                this.form.time[1] != this.form.time[0] &&
                Public.longDataToStr2(now.getTime()).substr(0, 10) ==
                    Public.longDataToStr2(this.form.time[1]).substr(0, 10)
            ) {
                console.log(3);
                endTime = (this.form.time[1] - 8 * 3600 * 1000 + 24 * 60 * 60 * 1000) / 1000;
            }
            let postData = {
                cec_id: Number(this.form.cec_id),
                station_id: this.form.selectSiteId ? Number(this.form.selectSiteId) : null,
                end_time: endTime,
                start_time: startTime,
                tel: Number(Public.removeSpace(this.form.mobile)),
                no: Public.removeSpace(this.form.no),
                connector_id: Public.removeSpace(this.form.connector_id),
				platform_id: this.form.platform_id
            };
            Object.keys(postData).forEach(key => {
                if (!postData[key]) {
                    delete postData[key];
                }
            });
            let params = {
                postData,
                callback: () => {
                    this.isExportLoading = false;
                },
            };
            let fileName; //文件名 格式 站点名 + 开始时间+结束时间
            // console.log(postData);
            if (this.form.selectSiteId) {
                for (let i = 0; i < this.siteIdList.length; i++) {
                    if (this.form.selectSiteId == this.siteIdList[i].id) {
                        // fileName =
                        //     this.siteIdList[i].name +
                        //     "(" +
                        //     Public.longDataToStr(new Date().getTime()).replace(/:/g, "-") +
                        //     ")";
                        fileName =
                            this.siteIdList[i].name +
                            "(" +
                            Public.longDataToStr2(postData.start_time * 1000) +
                            ")" +
                            "-" +
                            "(" +
                            Public.longDataToStr2(postData.end_time * 1000) +
                            ")";
                    }
                }
            } else {
                fileName =
                    "(" +
                    Public.longDataToStr2(postData.start_time * 1000) +
                    ")" +
                    "-" +
                    "(" +
                    Public.longDataToStr2(postData.end_time * 1000) +
                    ")";
            }
            console.log(Public.longDataToStr2(postData.start_time * 1000));
            console.log(Public.longDataToStr2(postData.end_time * 1000));
            await store.dispatch("exportOrderExcel", params);
            let blob = new Blob([this.orderBlob], { type: "application/vnd.ms-excel" }); //下载excel文件
            // let blob = new Blob([res.data], { type: "application/msword" }); //下载word文件
            let url = URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName + ".xlsx");
            document.body.appendChild(link);
            link.click();

            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
            loading.close();
        },
    },
};
</script>
<style scoped>
.search {
	display:flex;
	flex-direction:row;
	flex-wrap: wrap; 
	min-height: 3.5rem;
	width: 100%;
	align-items: center;
	border-radius: 0.8rem;
	background-color: #eff1f7;
}
.time {
    width: 17rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.box {
    width: 15rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.box1 {
    width: 12rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-search {
    width: 4rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.center {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
